import type { Package } from '@/models/package'
import type { PackageRedemption } from '@/models/package-redemption'
import { atom, map } from 'nanostores'

export const $package = atom<Package | null>(null)
export const $packages = atom<Array<Package>>([])
export const $redemptions = atom<Array<PackageRedemption>>([])
export const $promises = map<Record<string, Promise<any> | undefined>>()
